import { DateTime } from 'luxon';
import { type GqlCompany, type GqlMeeting, GqlMeetingKind } from '../../../../graphql/base-types.graphql';
import { isNil, minBy } from 'lodash-es';
import { getNextMeetingTime } from '../../../board-meetings/utils';

export interface DateSettings {
  maxDate?: DateTime;
  meetingDate?: DateTime;
}

export const getDefaultStartTime = (
  company: Pick<GqlCompany, 'boardSettings'>,
  meetingKind: GqlMeetingKind,
  lastMeetingDate?: DateTime,
  dateSettings?: DateSettings,
) => {
  let defaultMeetingTime = DateTime.fromObject({ hour: 12 }).plus({
    weeks: 6,
  });
  if (meetingKind !== GqlMeetingKind.BoardMeeting) {
    defaultMeetingTime = DateTime.fromObject({ hour: 12 }).plus({ weeks: 3 });
  }
  if (isNil(dateSettings?.meetingDate)) {
    if (meetingKind !== GqlMeetingKind.BoardMeeting || isNil(company.boardSettings) || isNil(lastMeetingDate)) {
      return defaultMeetingTime;
    }
    return getNextMeetingTime(lastMeetingDate, DateTime.now(), company.boardSettings);
  }
  const today = DateTime.fromObject({ hour: 12 });
  let date: DateTime;
  if (dateSettings.meetingDate.minus({ weeks: 3 }) > today) {
    date = defaultMeetingTime;
  } else {
    date = minBy([today, dateSettings!.meetingDate!], d => d.toMillis())!;
  }
  return date;
};

export const getDefaultMeetingNumber = (lastMeetingNumber?: string | null) => {
  if (isNil(lastMeetingNumber)) {
    return '1';
  }
  if (/^[0-9]+$/.test(lastMeetingNumber)) {
    return `${Number(lastMeetingNumber) + 1}`;
  }
  return '';
};

export const getDefaultPlace = (
  company: Pick<GqlCompany, 'address'>,
  lastMeeting: Pick<GqlMeeting, 'place'> | null | undefined,
) => {
  if (lastMeeting?.place) {
    return lastMeeting.place;
  }
  if (!company.address) {
    return '';
  }
  return `${company.address.address}, ${company.address.city}`;
};
